<template>
  <div class="entities-nav">
    <b-nav-item-dropdown
      end
      id="operation-menu"
      active-class="active"
      class="pointer"
      data-cy="entity"
      v-if="hasAnyAuthority(['ROLE_ORGA', 'ROLE_ADMIN'])"
    >
      <template #button-content>
        <span class="navbar-dropdown-menu">
          <font-awesome-icon icon="database" />
          <span class="no-bold">{{ $t('global.menu.entities.sales') }}</span>
        </span>
      </template>
      <div>
        <b-dropdown-item v-if="hasAnyAuthority(['ROLE_ORGA', 'ROLE_ADMIN'])" :to="spaceLink('statistics')">
          <font-awesome-icon icon="chart-bar" />
          <span>Statistiques</span>
        </b-dropdown-item>
        <b-dropdown-item v-if="hasAnyAuthority(['ROLE_ORGA', 'ROLE_ADMIN'])" :to="spaceLink('sale')">
          <font-awesome-icon icon="list" />
          <span>{{ $t('global.menu.entities.sale') }}</span>
        </b-dropdown-item>
        <b-dropdown-divider />
        <b-dropdown-item v-if="hasAnyAuthority(['ROLE_ORGA', 'ROLE_ADMIN'])" :to="spaceLink('cash-order')">
          <font-awesome-icon icon="shopping-cart" />
          <span>{{ $t('global.menu.entities.cashOrder') }}</span>
        </b-dropdown-item>
        <b-dropdown-item v-if="hasAnyAuthority(['ROLE_ORGA', 'ROLE_ADMIN'])" :to="spaceLink('transaction')">
          <font-awesome-icon icon="exchange-alt" />
          <span>{{ $t('global.menu.entities.transaction') }}</span>
        </b-dropdown-item>
        <b-dropdown-item v-if="hasAnyAuthority(['ROLE_ORGA', 'ROLE_ADMIN'])" :to="spaceLink('pending-email-send')">
          <font-awesome-icon icon="envelope" />
          <span>{{ $t('global.menu.entities.pendingEmailSend') }}</span>
        </b-dropdown-item>
        <b-dropdown-divider />
        <b-dropdown-item v-if="hasAnyAuthority('ROLE_ADMIN')" :to="spaceLink('cash-account')">
          <font-awesome-icon icon="users" />
          <span>{{ $t('global.menu.entities.cashAccount') }}</span>
        </b-dropdown-item>
        <b-dropdown-item v-if="hasAnyAuthority('ROLE_ADMIN')" :to="spaceLink('cash-account-item')">
          <font-awesome-icon icon="list-ul" />
          <span>{{ $t('global.menu.entities.cashAccountItem') }}</span>
        </b-dropdown-item>
      </div>
    </b-nav-item-dropdown>
    <b-nav-item-dropdown
      end
      id="entity-menu"
      active-class="active"
      class="pointer"
      data-cy="entity"
      v-if="hasAnyAuthority(['ROLE_ORGA', 'ROLE_ADMIN'])"
    >
      <template #button-content>
        <span class="navbar-dropdown-menu">
          <font-awesome-icon icon="th-list" />
          <span class="no-bold">{{ $t('global.menu.entities.management') }}</span>
        </span>
      </template>
      <div>
        <b-dropdown-item v-if="hasAnyAuthority(['ROLE_ORGA', 'ROLE_ADMIN'])" :to="spaceLink('cash-event')">
          <font-awesome-icon icon="calendar-alt" />
          <span>{{ $t('global.menu.entities.cashEvent') }}</span>
        </b-dropdown-item>
        <b-dropdown-item v-if="hasAnyAuthority(['ROLE_ORGA', 'ROLE_ADMIN'])" :to="spaceLink('sale-place')">
          <font-awesome-icon icon="map-marker-alt" />
          <span>{{ $t('global.menu.entities.salePlace') }}</span>
        </b-dropdown-item>
        <b-dropdown-divider />
        <b-dropdown-item v-if="hasAnyAuthority(['ROLE_ORGA', 'ROLE_ADMIN'])" :to="spaceLink('catalog')">
          <font-awesome-icon icon="book" />
          <span>{{ $t('global.menu.entities.catalog') }}</span>
        </b-dropdown-item>
        <b-dropdown-item v-if="hasAnyAuthority(['ROLE_ORGA', 'ROLE_ADMIN'])" :to="spaceLink('product')">
          <font-awesome-icon icon="cubes" />
          <span>{{ $t('global.menu.entities.product') }}</span>
        </b-dropdown-item>
        <b-dropdown-item v-if="hasAnyAuthority(['ROLE_ORGA', 'ROLE_ADMIN'])" :to="spaceLink('option')">
          <font-awesome-icon icon="list" />
          <span>{{ $t('global.menu.entities.option') }}</span>
        </b-dropdown-item>
        <b-dropdown-item v-if="hasAnyAuthority(['ROLE_ORGA', 'ROLE_ADMIN'])" :to="spaceLink('catalog-category')">
          <font-awesome-icon icon="th-list" />
          <span>{{ $t('global.menu.entities.catalogCategory') }}</span>
        </b-dropdown-item>
        <b-dropdown-item v-if="hasAnyAuthority(['ROLE_ORGA', 'ROLE_ADMIN'])" :to="spaceLink('illustration')">
          <font-awesome-icon icon="eye" />
          <span>{{ $t('global.menu.entities.illustration') }}</span>
        </b-dropdown-item>
        <b-dropdown-divider />
        <b-dropdown-item :to="spaceLink('printer-template')">
          <font-awesome-icon icon="save" />
          <span>{{ $t('global.menu.entities.printerTemplate') }}</span>
        </b-dropdown-item>
        <b-dropdown-divider />
        <b-dropdown-item v-if="hasAnyAuthority('ROLE_ADMIN')" :to="spaceLink('operator')">
          <font-awesome-icon icon="user-tie" />
          <span>{{ $t('global.menu.entities.operator') }}</span>
        </b-dropdown-item>
        <b-dropdown-item v-if="hasAnyAuthority('ROLE_ADMIN')" :to="spaceLink('operator-role')">
          <font-awesome-icon icon="users-cog" />
          <span>{{ $t('global.menu.entities.operatorRole') }}</span>
        </b-dropdown-item>
      </div>
    </b-nav-item-dropdown>
  </div>
</template>

<script lang="ts" src="./entities-menu.component.ts"></script>

<style scoped>
.jh-navbar a.nav-link,
.jh-navbar .no-bold {
  font-weight: 400;
}
.entities-nav {
  display: contents;
}
@media (min-width: 992px) and (max-width: 1199px) {
  .navbar-dropdown-menu {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
  }
  .navbar-dropdown-menu .no-bold::after {
    display: inline-block;
    margin-left: 0.25em;
    vertical-align: 0.2em;
    content: '';
    border-top: 0.3em solid;
    border-right: 0.3em solid transparent;
    border-bottom: 0;
    border-left: 0.3em solid transparent;
  }
}
@media (max-width: 991px) {
  .operation-menu {
    margin-left: 0;
  }
}
</style>
